import * as Yup from 'yup';
import { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';

const machineNameRegExp = /^[a-z0-9]+$/;

type CreateEditProps = {
  closeCreateEditForm: any;
  machineTypeEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  machineTypeEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const MachineTypeSchema = Yup.object().shape({
    // productId: Yup.string()
    // .required('Product is required')
    // .typeError('Product is required'),
    // machineType: Yup.string()
    //   //.required('Machine Type is required')
    //   .trim('Machine Type cannot include leading and trailing spaces')
    //   .matches(/^[a-z0-9A-Z\s]+$/, 'Special characters are not allowed')
    //   .min(3,'Machine Type must be at least 3 characters'),
    machineCode: Yup.string()
      .required('Machine Code is required')
      // .matches(
      //   /^[a-z0-9A-Z\s\-]+$/,
      //   'Invalid Machine Code. Only (-) character is allowed.'
      // )
      .min(3, 'Machine Code must be at least 3 characters')
      // .matches(
      //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
      //   'Machine Code cannot start with a special character'
      // )

      .trim('Machine Code cannot include leading and trailing spaces'),
    machineName: Yup.string()
      .min(3, 'Machine Name must be at least 3 characters')
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Machine Name only accepts special characters like &,[,],-,/,(,)'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Machine Name must include at least one letter of the alphabet'
      // )
      // .test(
      //   'no-leading-space',
      //   'Cannot start with a space',
      //   (value) => !value || value.trimStart() === value
      // )
      .required('Machine Name is required')

      .trim('Machine Name cannot include leading and trailing spaces'),
    machineRate: Yup.number()
      //.required('Machine Rate is required')
      //.typeError('Machine Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Machine Rate must be greater than or equal to 1')
      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .test(
        'len',
        'Length is too long',
        (val) =>
          !val ||
          (val && val.toString().includes('.')
            ? val.toString().length <= 10
            : val.toString().length <= 8)
      )
      .test(
        'max-two-decimals',
        'Machine Rate can have at most 2 decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
  });

  const [loader, setLoader] = useState(false);
  const [productLoader, setProductLoader] = useState(null);
  const [policyProductData, setPolicyProductData] = useState([]);
  const [policyProductValue, setPolicyProductValue] = useState('');
  const [policyProductSearchValue, setPolicyProductSearchValue] = useState('');
  const [noOptionsTextFlag, setNoOptionsTextFlag] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      productId: null,
      // machineType: '',
      machineCode: '',
      machineName: '',
      machineRate: '',
      status: true
    },
    validationSchema: MachineTypeSchema,
    onSubmit: (values) => {
      values.machineRate = String(values.machineRate);
      values.productId = productId;
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'machineType',
        method: method,
        data: values
      })
        .then((machineType) => {
          if (machineType.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.machineName);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: machineType['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = machineTypeEditDatas.id;
    // formik.initialValues.machineType = machineTypeEditDatas.machineType;
    formik.initialValues.machineCode = machineTypeEditDatas.machineCode;
    formik.initialValues.machineName = machineTypeEditDatas.machineName;
    formik.initialValues.machineRate = machineTypeEditDatas.machineRate;
    // formik.initialValues.productId = machineTypeEditDatas.productId;
    // console.log(machineTypeEditDatas.policyProduct.name)
    // setPolicyProductSearchValue(machineTypeEditDatas.policyProduct?.name);
    //setPolicyProductValue(machineTypeEditDatas?.policyProduct);
  }

  React.useEffect(() => {
    if (editStatus) {
      formik.initialValues.productId = machineTypeEditDatas.productId;
      setPolicyProductSearchValue(machineTypeEditDatas.policyProduct?.name);
      setPolicyProductValue(machineTypeEditDatas.policyProduct);
    }
  }, [editStatus]);
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  //Product fdetch api
  React.useEffect(() => {
    getpolicyProductData();
  }, [policyProductSearchValue]);

  const getpolicyProductData = () => {
    setProductLoader(true);
    setPolicyProductData([]);
    request({
      url: 'policyProduct/getAllowedPolicyProducts',
      method: 'post'
    }).then(
      (response: any) => {
        setProductLoader(false);
        if (response?.status == false) {
          setNoOptionsTextFlag(true);
          setPolicyProductData([]);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response.message
          });
        } else {
          setNoOptionsTextFlag(false);
          setPolicyProductData(response);
        }
      },
      (error) => {
        setProductLoader(false);
        console.log(error);
      }
    );
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Machine Type" />
              ) : (
                <CardHeader title="Create Machine Type" />
              )}

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        type="text"
                        label={
                          <React.Fragment>
                            Machine Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="machineName"
                        value={capitalizeFirst(formik.values.machineName)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.machineName &&
                          Boolean(formik.errors.machineName)
                        }
                        helperText={
                          formik.touched.machineName &&
                          formik.errors.machineName
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Machine Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="machineCode"
                        value={capitalizeFirst(formik.values.machineCode)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.machineCode &&
                          Boolean(formik.errors.machineCode)
                        }
                        helperText={
                          formik.touched.machineCode &&
                          formik.errors.machineCode
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        // label={
                        //   <React.Fragment>
                        //     Machine Rate{' '}
                        //     <Typography
                        //       component="span"
                        //       sx={{ color: 'red' }}
                        //     >
                        //       *
                        //     </Typography>
                        //   </React.Fragment>
                        // }
                        label={'Machine Rate'}
                        sx={{ width: '100%' }}
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        size="small"
                        name="machineRate"
                        value={formik.values.machineRate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.machineRate &&
                          Boolean(formik.errors.machineRate)
                        }
                        helperText={
                          formik.touched.machineRate &&
                          formik.errors.machineRate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
